import {
  Swiper,
  Navigation,
  Pagination,
  Autoplay
} from 'swiper';


Swiper.use([Navigation, Pagination, Autoplay]);

new Swiper('.model-slider', {
  speed: 600,
  spaceBetween: 0,
  slidesPerView: 1,
  autoplay: {
    delay: 5000,
  },
  loop: true,
  centeredSlides: true,
  pagination: {
    el: '.swiper-pagination',
    clickable: true
  },
});

new Swiper('.home-hero-slider', {
  speed: 600,
  autoplay: {
    delay: 5000,
  },
  spaceBetween: 0,
  slidesPerView: 1,
  loop: true,
  centeredSlides: true,
  pagination: {
    el: '.swiper-pagination',
    clickable: true
  },
});
